if (!customElements.get('wlsn-percentage')) {
  class WLSNPercentage extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        circle: 'js-wlsn-percentage',
        wrapper: 'js-wlsn-percentage-wrapper',
        ring: 'js-wlsn-percentage-ring',
      };

      this.elements = {
        circles: this.querySelectorAll(`.${this.classes.circle}`),
      };

      this.animated = false;

      this.defaultAnimationSpeed = 3000;
    }

    connectedCallback() {
      this.animationSpeed =
        Number(this.dataset.animationSpeed) || this.defaultAnimationSpeed;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animated) {
              this.animateCircles();
              this.animated = true;
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0.6 }
      );

      observer.observe(this);
    }

    animateCircles() {
      this.elements.circles.forEach((circle) => {
        const rings = circle
          .closest(`.${this.classes.wrapper}`)
          .querySelectorAll(`.${this.classes.ring}`);

        const targetPercent = parseFloat(circle.dataset.percentage);
        const barColor = circle.dataset.barColor;
        const barColorStart = circle.dataset.barColorStart || barColor;
        const barColorEnd = circle.dataset.barColorEnd || barColor;
        const fadedColor = circle.dataset.barOpacity;

        const duration = this.animationSpeed;
        const startTime = performance.now();

        const formatValue = (value) =>
          Number.isInteger(value) ? value : value.toFixed(1);

        const paint = (angle) => {
          rings.forEach((ring) => {
            ring.style.background = `
              conic-gradient(
                ${barColorStart} 0deg,
                ${barColorEnd} ${angle}deg,
                ${fadedColor} ${angle}deg
              )
            `;
          });
        };

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);

          const currentPercent = targetPercent * progress;
          const angle = (currentPercent / 100) * 360;

          paint(angle);

          circle.textContent = `${formatValue(currentPercent)}%`;

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            paint((targetPercent / 100) * 360);
            circle.textContent = `${formatValue(targetPercent)}%`;
          }
        };

        requestAnimationFrame(animate);
      });
    }
  }

  customElements.define('wlsn-percentage', WLSNPercentage);
}
